


import { Box } from '@mui/system';
import { Card, CardHeader, CardContent } from '@mui/material';

import { useTranslate } from 'src/locales';
import { TaskLinkedEntityType } from 'src/services/tasks/tasks.types';
import PostCommentForm from 'src/layouts/common/threads/post-comment-form';
import PostCommentList from 'src/layouts/common/threads/post-comment-list';
import { useGetOrganizationCandidateQuery } from 'src/services/candidates/candidates.service';

import Iconify from 'src/components/iconify';
import ListSkeleton from 'src/components/list/list-skeleton';

import LinkedTasks from 'src/sections/tasks/components/linked-tasks';

type Props = {
  candidateId: string;
};

export const CandidateDetailSection = ({ candidateId }: Props) => {
  const { t } = useTranslate();

  const { currentData: orgCandidate, isLoading } = useGetOrganizationCandidateQuery(
    candidateId,
    {
      skip: !candidateId,
    }
  );

  if (isLoading) {
    return <ListSkeleton />;
  }

  if (!orgCandidate?.thread?.id) {
    return null;
  }

  return (
    <Card>
      <CardHeader
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Iconify icon="uil:notes" />
            <Box>{t('companies.profile.thread.title')}</Box>
          </Box>
        }
      />
      <CardContent>
        {/* Notes are written to the candidate's own thread, as they always have been. The list
            below merges in what was written on their applications — see PostCommentList's `feed`. */}
        <PostCommentForm thread_id={orgCandidate.thread.id} />
        {/* Includes tasks on the candidate's applications, like the notes list below. */}
        <LinkedTasks entityType={TaskLinkedEntityType.CANDIDATE} entityId={candidateId} />
        <PostCommentList feed={{ type: 'candidate', id: candidateId }} />
      </CardContent>
    </Card>
  )
};